<template>
  <v-card class="pa-3">
    <v-card-title>
      <h2>{{ title }}</h2>
    </v-card-title>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('Search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="pagination.totalItems"
    >
      <template slot="items" slot-scope="props">
        <td v-for="col of headers" :key="col.value">
          <template v-if="!Array.isArray(props.item[col.value])">
            <template v-if="col.value == 'action'">
              <!-- Prps Items: {{props.item.id}} vModel: {{customerIds}} -->
              <v-switch v-model="customerIds" :value="props.item.id"></v-switch>
            </template>
            <template v-else>
              {{ props.item[col.value] }}
            </template>
          </template>
          <template v-if="Array.isArray(props.item[col.value])">
            <template v-for="ob of props.item[col.value]">
              {{ ob }} &nbsp;
            </template>
          </template>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="initialize">{{ $t('Reset') }}</v-btn>
      </template>
      <template slot="footer"></template>
    </v-data-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save" :disabled="!item || !item.CLAVEDAT">
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ProfileAPI from '@/services/api/profile.js';
import CustomerModel from '@/modules/admin/customers-and-consultants/models/customer.js';
export default {
  props: {
    title: String,
    item: Object,
    initialData: Object,
  },
  data() {
    return {
      search: '',
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      loading: true,
      items: [],
      formDialog: false,
      editedItem: {},
      customerId: null,
      customerIds: [],
      headers: [],
    };
  },

  mounted() {
    this.initialize();
  },
  computed: {
    currentPage() {
      return this.pagination.page;
    },
    perPage() {
      return this.pagination.rowsPerPage;
    },
  },

  methods: {
    getCustomerIds() {
      let result = [];
      this.item.customers.forEach(customer => {
        result.push(customer.id);
      });
      this.customerIds = result;
    },
    initialize() {
      console.log({ ItemToLink: this.item });
      this.loading = true;

      if (this.initialData) {
        console.log('INITIAL DATAAAAA');
        console.log(this.initialData);
        this.items = this.initialData.data.data;
        this.headers = this.initialData.data.dataTable.headers;
        this.loading = false;
      } else {
        this.getItems();
      }
    },
    getItems() {
      this.loading = true;

      const config = {
        params: {
          page: this.pagination.page,
          per_page: this.pagination.rowsPerPage,
          search: this.search,
        },
      };

      ProfileAPI.getMiniList('customer', config).then(response => {
        // // console.log(response);
        this.items = response.data.data;

        this.structure = response.data.structure;
        this.headers = response.data.dataTable.headers;

        this.pagination = {
          descending: this.pagination.descending,
          page: response.data.meta.current_page,
          rowsPerPage: Number(response.data.meta.per_page), // -1 for All",
          sortBy: this.pagination.sortBy,
          totalItems: Number(response.data.meta.total),
        };

        this.$emit('initialDataLoaded', { data: response.data });
        console.log(this.headers);
        console.log(this.items);
        this.loading = false;
      });
    },

    getItemsIfStopChanging() {
      this.loading = true;
      const params = {
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage,
        search: this.search,
      };

      setTimeout(() => {
        if (
          params.page === this.pagination.page &&
          params.per_page === this.pagination.rowsPerPage &&
          params.search === this.search
        ) {
          this.getItems();
        }
      }, 300);
    },

    save() {
      let data = {
        customer_id: this.customerIds,
        clavedat: this.item.CLAVEDAT,
      };
      console.log(data);
      ProfileAPI.linkAplifisaToUser(data).then(res => {
        this.$emit('fiscalSaved', {
          empresa: res.data.data,
          index: this.editedIndex,
        });

        this.customerId = null;
      });
      this.formDialog = false;
    },

    getEmptyProfileModel() {
      return CustomerModel.CustomerModel();
    },
    editItem(item) {
      // console.log(item);
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // this.$emit('editItem', this.editedItem);
      this.formDialog = true;
    },

    addNew() {
      this.editedIndex = null;
      this.editedItem = this.getEmptyProfileModel();
      this.formDialog = true;
    },
    // closeDialog() {
    //   this.formDialog = false;
    // },

    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm(this.$t('Are you sure you want to delete this item?')) && this.items.splice(index, 1);
      ProfileAPI.deleteProfile('customer', item.id).then(res => {
        console.log(res);
      });
    },
    profileSaved(data) {
      console.log(data);
      if (data.index) {
        this.items.splice(data.index, 1, data.profile);
      } else {
        this.items.push(data.profile);
      }
      this.formDialog = false;
    },
    closeDialog(closeDialog) {
      if (closeDialog) {
        this.formDialog = false;
        this.editedItem = this.getEmptyProfileModel();
      }
    },
  },
  watch: {
    search: function() {
      if (this.currentPage === 1) {
        this.getItemsIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    currentPage: function() {
      this.getItemsIfStopChanging();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getItemsIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },

    item: {
      handler: function(val) {
        console.log(this.item);
        if (val) {
          this.getCustomerIds();
        }
      },
      deep: true,
    },
  },
};
</script>
